const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/support-config.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/support-config")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Support Page",
      description: "Tab title for support configuration"
    })
  }
});